import { hasProp } from "../helpers/Class";

class Customer {
    constructor(customer = null) {
        this.id = !hasProp(customer, "id") ? undefined : customer.id;
        this.firstName = !hasProp(customer, "firstName") ? undefined : customer.firstName;
        this.lastName = !hasProp(customer, "lastName") ? undefined : customer.lastName;

        this.selected = !hasProp(customer, "selected") ? false : customer.selected;
    }
}

export default Customer;